module.exports = __webpack_public_path__ + "static/media/pathfinding.16fc286e.png";